<template>
  <div class="mm-qr">
    <div class="mm-qr-top">
      <div class="mm-qr-frame">
        <img :src="apiUrl + '/custom/invitation/qr/' + invitation.token" width="150" height="150">
      </div>
      <p class="mm-qr-caption">
        Scan to join
        <span class="mm-strong">{{ invitation.locationName }}</span> ·
        <span class="mm-strong">{{ invitation.pathwayName }}</span> ·
        <span class="mm-strong">{{ invitation.stepName }}</span>
      </p>
    </div>

    <div class="mm-block">
      <label class="mm-mini-label"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-link2 lucide-link-2 w-3.5 h-3.5" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/InvitationQRDisplay.tsx:145:10" data-component-name="Link2"><path d="M9 17H7A5 5 0 0 1 7 7h2"></path><path d="M15 7h2a5 5 0 1 1 0 10h-2"></path><line x1="8" x2="16" y1="12" y2="12"></line></svg> Shareable link</label>
      <div class="mm-row">
        <input
          class="mm-input mm-mono mm-xs"
          readonly
          :value="invitation.link"
          @focus="$event.target.select()"
        />
        <button type="button" class="mm-btn mm-btn--blue" @click="copy(invitation.link, 'link')">
          <svg v-if="copiedLink" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check w-3 h-3" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/pages/MenteeJoinFlow.tsx:543:22" data-component-name="Check"><path d="M20 6 9 17l-5-5"></path></svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-copy w-4 h-4" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/InvitationQRDisplay.tsx:156:58" data-component-name="Copy"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path></svg>
          <span class="mm-btn-text">{{ copiedLink ? "Copied" : "Copy" }}</span>
        </button>
      </div>
    </div>

    <div class="mm-block">
      <label class="mm-mini-label"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-key-round w-3.5 h-3.5" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/InvitationQRDisplay.tsx:164:10" data-component-name="KeyRound"><path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z"></path><circle cx="16.5" cy="7.5" r=".5" fill="currentColor"></circle></svg> Access password</label>
      <div class="mm-row">
        <input
          class="mm-input mm-mono"
          :type="showPw ? 'text' : 'password'"
          readonly
          :value="invitation.password"
        />
        <button
          type="button"
          class="mm-icon-btn"
          :aria-label="showPw ? 'Hide password' : 'Show password'"
          @click="showPw = !showPw"
        >
          <svg v-if="showPw" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye-off w-4 h-4" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/InvitationQRDisplay.tsx:177:22" data-component-name="EyeOff"><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"></path><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"></path><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"></path><path d="m2 2 20 20"></path></svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye w-4 h-4" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/InvitationQRDisplay.tsx:177:55" data-component-name="Eye"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
        </button>
        <button
          type="button"
          class="mm-btn mm-btn--blue"
          @click="copy(invitation.password, 'password')"
        >
          <svg v-if="copiedPw" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check w-3 h-3" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/pages/MenteeJoinFlow.tsx:543:22" data-component-name="Check"><path d="M20 6 9 17l-5-5"></path></svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-copy w-4 h-4" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/InvitationQRDisplay.tsx:156:58" data-component-name="Copy"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path></svg>
          <span class="mm-btn-text">{{ copiedPw ? "Copied" : "Copy" }}</span>
        </button>
      </div>
      <p class="mm-note">
        <svg xmlns="http://www.w3.org/2000/svg" width="10.25" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-check w-3 h-3" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/InvitationQRDisplay.tsx:206:10" data-component-name="ShieldCheck"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path><path d="m9 12 2 2 4-4"></path></svg> Share the password separately so a stray QR/link can't join the wrong account.
      </p>
    </div>
    <div class="flex items-center justify-between gap-3 rounded-lg border bg-background px-3 py-2.5">
      <div class="space-y-0.5">
        <label class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-xs font-medium" for="include-pw-inv_zgrightvpta">Show password on PDF</label>
        <p class="text-[11px] text-muted-foreground mb-0">Turn off to share the password separately.</p>
      </div>
      <label class="switch" style="margin-left: 10px; margin-top: 5px; padding: 0;">
        <input type="checkbox" v-model="password_show" @change="openAuthModal($event)" :checked="multifactor_authentication">
        <span class="slider round"></span>
      </label>
    </div>

    <button
      type="button"
      class="mm-btn mm-btn--outline mm-btn--full"
      :disabled="downloading"
      @click="downloadPdf"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-download w-4 h-4 mr-2" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/InvitationQRDisplay.tsx:197:8" data-component-name="Download"><path d="M12 15V3"></path><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><path d="m7 10 5 5 5-5"></path></svg>
      <span class="mm-btn-text">{{
        downloading ? "Preparing PDF…" : "Download as PDF"
      }}</span>
    </button>
  </div>
</template>

<script>
import axios from 'axios';
import { notify } from "../../toastStore";

export default {
  name: "InvitationQRDisplay",
  props: {
    invitation: { type: Object, required: true },
    basePath: { type: String, default: "/" },
  },
  data() {
    return {
      copiedLink: false,
      copiedPw: false,
      showPw: false,
      downloading: false,
      link: '',
      apiUrl: process.env.API_ENDPOINT,
      password_show: true,
    };
  },
  mounted() {
    this.renderQr();
  },
  methods: {
    renderQr() {

    },
    async copy(text, kind) {
      try {
        console.log(window.isSecureContext);
        if (kind === "link") {
          this.copiedLink = true;
          setTimeout(() => (this.copiedLink = false), 2000);
        } else {
          this.copiedPw = true;
          setTimeout(() => (this.copiedPw = false), 2000);
        }
        const textarea = document.createElement('textarea');

        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';

        document.body.appendChild(textarea);

        textarea.select();
        document.execCommand('copy');

        document.body.removeChild(textarea);
        notify({
          title: kind === "link" ? "Link copied" : "Password copied",
        });
        
      } catch (e) {
        notify({
          title: "Copy failed",
          description: "Select the value and copy it manually.",
          variant: "destructive",
        });
        
      }
    },
    async downloadPdf() {
      this.downloading = true;
      axios.get('/account-invitation-pdf/' + this.invitation.id, {
        params: {
          password_show: this.password_show,
        },
      })
      .then(response =>  {
        this.downloading = false;
        this.pdf_file_name = response.data.pdf_file_name;
        const safeName = this.invitation.locationName
          .replace(/[^a-z0-9]+/gi, "-")
          .toLowerCase();
        this.showOverlay = false;
        var url = this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name;

        //Create XMLHTTP Request.
        var req = new XMLHttpRequest();
        req.open("GET", url, true);
        req.responseType = "blob";
        req.onload = function () {
            //Convert the Byte Data to BLOB object.
            var blob = new Blob([req.response], { type: "application/octetstream" });

            //Check the Browser type and download the File.
            var isIE = false || !!document.documentMode;
            if (isIE) {
                window.navigator.msSaveBlob(blob, fileName);
            } else {
                var url = window.URL || window.webkitURL;
                var link = url.createObjectURL(blob);
                var a = document.createElement("a");
                a.setAttribute("download", "invitation-" + safeName + " .pdf");
                a.setAttribute("href", link);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
            notify({
              title: "PDF downloaded",
              description: "The invitation PDF has been saved.",
            });
        };
        req.send();
        return false;
      })
      .catch(function(error) {
        console.log(error);
        notify({
          title: "Download failed",
          description: "Could not generate the PDF. Please try again.",
          variant: "destructive",
        });
      });

    },
  },
};
</script>

<style scoped>
.mm-qr {
  border: 1px solid #e4e9ec;
  border-radius: 12px;
  background: rgba(0, 47, 66, 0.03);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.mm-qr-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.mm-qr-frame {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  line-height: 0;
}
.mm-qr-canvas {
  display: block;
  width: 180px;
  height: 180px;
}
.mm-qr-caption {
  margin: 0;
  font-size: 12px;
  color: #6b7785;
  text-align: center;
}
.mm-strong {
  color: #1f2a30;
  font-weight: 500;
}
.mm-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.mm-mini-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #6b7785;
}
.mm-row {
  display: flex;
  gap: 8px;
}
.mm-input {
  width: 100%;
  box-sizing: border-box;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #d6dde1;
  border-radius: 8px;
  font-size: 14px;
  color: #1f2a30;
  background: #fff;
  outline: none;
}
.mm-input:focus {
  border-color: #00acee;
  box-shadow: 0 0 0 3px rgba(0, 172, 238, 0.15);
}
.mm-xs {
  font-size: 12px;
}
.mm-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}
.mm-icon-btn {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6dde1;
  border-radius: 8px;
  background: #fff;
  color: #1f2a30;
  cursor: pointer;
}
.mm-icon-btn:hover {
  background: #f3f5f6;
}
.mm-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid transparent;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.mm-btn-text {
  white-space: nowrap;
}
.mm-btn--blue {
  flex: 0 0 auto;
  background: #00acee;
  color: #fff;
}
.mm-btn--blue:hover {
  background: #0095d0;
}
.mm-btn--outline {
  background: #fff;
  border-color: #d6dde1;
  color: #1f2a30;
}
.mm-btn--outline:hover {
  background: #f3f5f6;
}
.mm-btn--full {
  width: 100%;
}
.mm-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.mm-note {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #6b7785;
}
.rounded-lg {
    border-radius: 0.625rem !important;
}
.px-3 {
    padding-inline: calc(0.25rem * 3);
}
.text-xs {
    font-size: 13px;
    line-height: cal(1/0.75);
}
.font-medium {
    --tw-font-weight: 700;
    font-weight: 700;
    margin-bottom: 0 !important;
}
.py-2\.5 {
    padding-block: calc(0.25rem * 2.5);
}
.text-muted-foreground {
    color: #627384;
}
.text-\[11px\] {
    font-size: 11px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;

}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;

}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #DAE0E7;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 2px;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #FFF;
}

input:checked + .slider {
  background-color: #00ACF0;
}
input:checked + .slider:before {
  background-color: #FFF;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.gap-3 {
    gap: calc(0.25rem * 3);
}
.flex {
    display: flex;
}
.justify-between {
    justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/InvitationQRDisplay.vue